import {
  aadharPlaceholder,
  birthCertificate,
  transferCertificate,
} from "../../../asset";
import DocumentUpload from "../../../components/common/DocumetUpload";
import SubHeadings from "../../../components/SubHeadings";
import { Student } from "../../../types/studentType";
import { useFormEdit } from "../../../util/hooks/useFormEdit";

interface documentInformationProps {
  form: ReturnType<typeof useFormEdit<Student>>;
}

export default function DocumentDetails({ form }: documentInformationProps) {
  const { formData, setFormData, isEditing } = form;

  const handleUpload = (field: keyof Student, url: string) => {
    setFormData((prev) => ({
      ...prev,
      [field]: url,
    }));
  };

  return (
    <div className="md:px-9 px-4 pb-16">
      <div className="flex flex-col gap-7 w-full py-7">
        <SubHeadings text="Document Details" />
        <div className="grid md:grid-cols-3 max-w-lg mx-auto md:max-w-7xl lg:w-full h-full gap-y-24 md:gap-16">
          <DocumentUpload
            label="Birth certificate"
            onUploadComplete={(url) => handleUpload("birthCertificateUrl", url)}
            placeholderImage={birthCertificate}
            borderStyle="solid"
            buttonWidth="fit"
            buttonAlign="right"
            buttonText="Upload"
            className="w-full"
            value={formData.birthCertificateUrl || ""}
            disabled={!isEditing}
          />
          <DocumentUpload
            label="Transfer certificate (TC)"
            onUploadComplete={(url) =>
              handleUpload("transferCertificateUrl", url)
            }
            placeholderImage={transferCertificate}
            borderStyle="solid"
            buttonWidth="fit"
            buttonAlign="right"
            buttonText="Upload"
            className="w-full"
            value={formData.transferCertificateUrl || ""}
            disabled={!isEditing}
          />
          <DocumentUpload
            label="Aadhar card"
            onUploadComplete={(url) => handleUpload("aadharCardUrl", url)}
            placeholderImage={aadharPlaceholder}
            borderStyle="solid"
            buttonWidth="fit"
            buttonAlign="right"
            buttonText="Upload"
            className="w-full"
            value={formData.aadharCardUrl || ""}
            disabled={!isEditing}
          />
        </div>
      </div>
    </div>
  );
}
